<template>
    <NuxtLink
        :to="to"
        class="card"
        :class="{'card--horizontal': isInline}"
    >
        <div class="card__image">
            <slot name="image">
                <BaseImage
                    sizes="(max-width: 900px) 95vw, 780px"
                    :image="image"
                    :title="image.title"
                    :width="image.width"
                    :height="image.height"
                />
            </slot>

            <div v-if="$slots.label" class="card__label">
                <slot name="label" />
            </div>
        </div>

        <div class="card__title card-title--mobile">
            <slot name="title">{{ title }}</slot>
        </div>

        <div class="card__content">
            <div class="card__title card-title--desktop">
                <slot name="title">{{ title }}</slot>
            </div>

            <div class="card__info">
                <slot name="info" />
            </div>

            <div v-if="$slots.default" class="card__details">
                <slot />
            </div>
        </div>
    </NuxtLink>
</template>

<script setup>
import BaseImage from '@/components/BaseImage/BaseImage.vue';

defineProps({
    title: {
        type: String,
        required: true,
        default: null
    },
    to: {
        type: [String, Object],
        required: true,
        default: null
    },
    location: {
        type: String,
        required: false,
        default: null
    },
    date: {
        type: String,
        required: false,
        default: null
    },
    image: {
        type: Object,
        required: false,
        default: null
    },
    isInline: {
        type: Boolean,
        required: false,
        default: false
    }
});
</script>

<style lang="less" src="./BaseCard.less" />
